import React, { PureComponent } from "react";

import NumericLabel from "react-pretty-numbers";

import numeral from "numeral";
import Select from "react-select";

import styles from "./style.module.css";

import { Button, ButtonGroup } from "aible";

import { Popover, OverlayTrigger } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faChevronUp, faChevronDown, faUndo } from "@fortawesome/free-solid-svg-icons";

import { colors as nextColors } from "containers/Next/NextReducer";
import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import NextChart from "components/Next/Charts/NextChart";

import VotingIcon from "images/Next-Icons/model-voting.svg";

export default class InfoChart extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hoveredItem: undefined
    };
  }

  getIsNumeric() {
    const { dataset } = this.props;

    const outcome = dataset?.outcome;
    const oField = dataset?.fields?.[outcome];

    return oField?.type === "number";
  }

  renderIgnoreButton(fieldValue, delta) {
    const { ignoreDelta, updateIgnoreDelta } = this.props;

    return (
      <div className={styles.extraDeltaRemove}>
        <Button
          onClick={() =>
            updateIgnoreDelta({
              ...ignoreDelta,
              [fieldValue]: {
                ...(ignoreDelta?.[fieldValue] || {}),
                [delta?.name]: true
              }
            })
          }
          style={{ padding: "3px" }}
        >
          <FontAwesomeIcon icon={faMinus} />
        </Button>
      </div>
    );
  }

  render() {
    const {
      id,
      field,
      value,
      count,
      chart,
      dataset,
      average,
      onExpand,
      rankIndex,
      ignoreDelta,
      ignoreInfoChartField,
      updateIgnoreInfoChartField,
      updateIgnoreDelta,
      extraCount,
      updateExtraCount,
      scoreRatio,
      barTooltipPosition,
      dashboardSubchartsCount,
      isChat,
      focusColumn,
      focusValue,
      customStyle
    } = this.props;

    const { hoveredItem } = this.state;

    const tooltipPosition = barTooltipPosition ?? "bottom";

    const isNumeric = this.getIsNumeric();

    const getDelta = (d) => (isNaN(d.y) ? 0 : d.y) - (isNaN(d.otherY) ? 0 : d.otherY);

    const getCount = (c, name) => c?.data?.summary?.getTotalN();

    const cWidth = "calc(" + 100 / 5 + "% - 20px)";

    const maxScore =
      chart?.insights !== undefined ? chart.insights.reduce((a, b) => (a > b.score ? a : b.score), 0) : 1;

    const rawAverage = average !== undefined ? average : chart?.dataSlice?.y;
    const retCount = count !== undefined ? count : chart?.dataSlice?.summary?.getTotalN();

    const retAverage = isNumeric ? Number(numeral(rawAverage).format("0.[000]")) : rawAverage;

    return (
      <div className={isChat ? styles.infoChartChat : styles.infoChart} style={customStyle ?? {}}>
        <div className={styles.infoChartField} style={isChat ? { width: "100%", height: "auto" } : {}}>
          {isChat !== true && (
            <div className={styles.infoIgnoreField}>
              <Button
                className={styles.infoExtraButton}
                onClick={() =>
                  updateIgnoreInfoChartField({
                    ...ignoreInfoChartField,
                    [field + ": " + value]: true
                  })
                }
              >
                <FontAwesomeIcon icon={faMinus} />
              </Button>
            </div>
          )}
          <div className={styles.infoChartInsightFieldLeft}>
            {chart?.base !== undefined && (
              <div className={styles.infoChartInsightTinyMuscleScoreDash}>
                <LeakageChartContainer
                  id={id}
                  height={120}
                  width={120}
                  innerRadius={16}
                  node={chart?.base}
                  insight={chart?.base}
                  isTiny
                  hideChords={false}
                  isDashboard
                  isInfoChart
                />
              </div>
            )}
            <div className={styles.tOverflow} title={field + ": " + value}>
              {field + ": " + value}
            </div>
          </div>
          <div className={styles.scoreBarOuter} style={{ marginTop: "10px" }}>
            <div
              className={styles.scoreBarInner}
              style={{
                width: scoreRatio * 100 + "%"
              }}
            />
          </div>
          <div className={styles.overallAvg}>{"Average: " + retAverage + (isNumeric ? "" : "%")}</div>
          <div className={styles.infoChartMini}>
            <OverlayTrigger
              placement="right"
              trigger={
                [
                  /*"hover"*/
                ]
              }
              rootClose
              overlay={
                <Popover id="popover-positioned-top" title={chart?.fixedBase?.narrative?.title}>
                  <div
                    style={{
                      height: "300px",
                      width: "500px"
                    }}
                  >
                    {!isNaN(retCount) && <div>{`Count: ${retCount}`}</div>}
                    <NextChart
                      id={id}
                      dataset={dataset}
                      chart={chart?.fixedBase}
                      isHideNarrative
                      hideTitle
                      highlightProps={value}
                      showLeakage
                    />
                  </div>
                </Popover>
              }
            >
              <div
                className={styles.infoFull}
                onClick={() => {
                  onExpand(chart?.base);
                }}
              >
                <NextChart
                  id={id}
                  dataset={dataset}
                  chart={chart?.fixedBase}
                  isHideNarrative
                  hideTitle
                  highlightProps={value}
                  showLeakage
                  isSmall
                />
              </div>
            </OverlayTrigger>
          </div>
        </div>
        <div
          className={styles.infoChartInsightsContainer}
          style={isChat ? { flexWrap: "wrap", justifyContent: "center", borderLeft: "none" } : {}}
        >
          {chart.insights &&
            chart.insights
              .filter(
                (insight, i) => focusColumn === undefined || insight?.metadata?.properties?.[0].column === focusColumn
              )
              .filter((insight, i) => i < dashboardSubchartsCount)
              .map((insight, i) => {
                const insightField = insight?.metadata?.properties?.[0].column;

                const normalSortedDeltas = [...insight?.chart.data]
                  .sort((a, b) => getDelta(b) - getDelta(a))
                  .map((a) => ({
                    delta: getDelta(a),
                    name: a.name,
                    data: a
                  }));

                const sortedDeltas = [...insight?.chart.data]
                  .sort((a, b) => Math.abs(getDelta(b)) - Math.abs(getDelta(a)))
                  .sort((a, b) =>
                    focusValue === undefined ? 0 : a.name === focusValue ? -1 : b.name === focusValue ? 1 : 0
                  )
                  .map((a) => ({
                    delta: getDelta(a),
                    name: a.name,
                    data: a
                  }));

                const extraDeltas = sortedDeltas
                  ? sortedDeltas.filter((s, i) => i > 0 && i < sortedDeltas.length - 1 && i < extraBarCount + 1)
                  : undefined;

                const posStyle = {
                  background: "#20CAE8"
                };
                const negStyle = {
                  background: "#E396F5"
                };

                const scoreRatio = insight.score / maxScore;

                const extraBarCount =
                  extraCount?.[field + ": " + value + "_" + insightField] !== undefined
                    ? extraCount?.[field + ": " + value + "_" + insightField]
                    : 0;

                const finalDeltas = sortedDeltas.filter((delta, i) => {
                  const showIndex = i < 3 + extraBarCount;
                  const notIgnored = ignoreDelta?.[field + ": " + value]?.[delta.name] !== true;
                  if (showIndex && notIgnored) {
                    return true;
                  }
                  return false;
                });

                const chartAllowedValues = finalDeltas
                  .map((delta) => delta?.name)
                  .filter((delta) => delta !== undefined);

                return (
                  <div className={styles.infoChartInsight} key={"insight_" + i}>
                    <div className={styles.infoExtra}>
                      <div className={styles.infoExtraCount}>
                        {Math.min(extraBarCount + 3, sortedDeltas.length) + "/" + sortedDeltas.length}
                      </div>
                      {/* <ButtonGroup>
												<Button
													className={
														styles.infoExtraButton
													}
													disabled={
														!(
															sortedDeltas &&
															sortedDeltas.length >
																extraBarCount + 3
														)
													}
													onClick={() =>
														updateExtraCount({
															...extraCount,
															[field +
															": " +
															value +
															"_" +
															insightField]:
																extraBarCount + 1,
														})
													}
												>
													{"+"}
												</Button>
												<Button
													className={
														styles.infoExtraButton
													}
													disabled={extraBarCount <= 0}
													onClick={() =>
														updateExtraCount({
															...extraCount,
															[field +
															": " +
															value +
															"_" +
															insightField]:
																extraBarCount - 1,
														})
													}
												>
													{"-"}
												</Button>
												<Button
													className={
														styles.infoExtraButton
													}
													onClick={() => {
														updateExtraCount({
															...extraCount,
															[field +
															": " +
															value +
															"_" +
															insightField]: 0,
														});
														updateIgnoreDelta({
															...ignoreDelta,
															[field +
															": " +
															value]: undefined,
														});
													}}
													disabled={
														ignoreDelta?.[
															field + ": " + value
														] === undefined &&
														extraCount?.[
															field +
																": " +
																value +
																"_" +
																insightField
														] === undefined
													}
												>
													<FontAwesomeIcon
														icon={faUndo}
													/>
												</Button>
											</ButtonGroup> */}
                    </div>
                    <div className={styles.infoChartInsightField} style={{ fontSize: "16px" }}>
                      {chart?.base !== undefined && (
                        <div className={styles.infoChartInsightTinyMuscleScoreDash}>
                          <LeakageChartContainer
                            id={id}
                            height={120}
                            width={120}
                            innerRadius={16}
                            node={insight}
                            insight={insight}
                            isTiny
                            hideChords={false}
                            isDashboard
                            isInfoChart
                          />
                        </div>
                      )}
                      <div className={styles.tOverflow} title={insightField}>
                        {insightField}
                      </div>
                    </div>
                    <div className={styles.scoreBarOuter}>
                      <div
                        className={styles.scoreBarInner}
                        style={{
                          width: scoreRatio * 100 + "%"
                        }}
                      />
                    </div>
                    <div className={styles.infoChartInsightGraph}>
                      {finalDeltas &&
                        finalDeltas.map((delta) => {
                          const diffFromAverage = delta?.delta - retAverage;
                          const retDelta = isNumeric ? diffFromAverage / (retAverage || 1) : diffFromAverage;

                          const chartDelta = delta?.delta;

                          const handleMouseEnter = () => {
                            if (hoveredItem?.delta !== delta?.name || hoveredItem?.insight !== insight) {
                              const newHoverItem = {
                                delta: delta?.name,
                                insight: insight
                              };
                              this.setState({ hoveredItem: newHoverItem });
                            }
                          };

                          const handleMouseLeave = () => {
                            if (hoveredItem) {
                              this.setState({ hoveredItem: undefined });
                            }
                          };
                          const outcome = dataset?.outcome;
                          const isContinuousOutcome = dataset?.fields?.[outcome]?.type === "number";

                          return (
                            <div
                              className={styles.benchmarkColumnWrapper}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                              onClick={() => onExpand(insight, delta?.name)}
                              key={"deltaValue__" + delta?.name}
                            >
                              <OverlayTrigger
                                placement={tooltipPosition}
                                trigger={
                                  [
                                    /*"hover"*/
                                  ]
                                }
                                rootClose
                                overlay={
                                  <Popover id="popover-positioned-top" title={insightField + " is " + delta?.name}>
                                    <div
                                      style={{
                                        height: "300px",
                                        width: "500px"
                                      }}
                                    >
                                      <div>{"Count:" + getCount(delta)}</div>
                                      <NextChart
                                        id={id}
                                        dataset={dataset}
                                        chart={insight}
                                        isHideNarrative
                                        hideTitle
                                        highlightProps={delta?.name}
                                      />
                                    </div>
                                  </Popover>
                                }
                              >
                                <div className={styles.benchmarkColumn}>
                                  <div className={styles.infoTextTop}>
                                    <div
                                      className={styles.infoValue}
                                      title={delta.name}
                                      onClick={() => onExpand(insight, delta?.name)}
                                    >
                                      {delta.name && delta.name.length > 20
                                        ? delta.name.substring(0, 20) + "..."
                                        : delta.name}
                                    </div>
                                  </div>
                                  <div className={styles.benchmarkDeltaChart}>
                                    <div className={styles.benchmarkBarChart}>
                                      <NextChart
                                        id={id}
                                        dataset={dataset}
                                        chart={insight}
                                        isHideNarrative
                                        hideTitle
                                        highlightProps={
                                          hoveredItem?.insight === insight && hoveredItem?.delta
                                            ? hoveredItem?.delta
                                            : focusValue !== undefined
                                              ? focusValue
                                              : undefined
                                        }
                                        isSmall
                                        allowedSecondOrderValuesOrdered={chartAllowedValues}
                                        onlyShowData={[delta?.name]}
                                      />
                                    </div>
                                  </div>
                                  <div className={styles.benchmarkDeltaValue}>
                                    <div className={chartDelta >= 0 ? styles.infoBadgeGood : styles.infoBadgeBad}>
                                      {(chartDelta >= 0 ? "+" : "-") +
                                        Math.abs(chartDelta).toFixed(2) +
                                        (isContinuousOutcome ? "" : "%")}
                                    </div>
                                  </div>
                                </div>
                              </OverlayTrigger>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
    );
  }
}
